import React, { useEffect, useState } from "react";
import { Button, DrawerBody, DrawerFooter, DrawerHeader, DrawerHeaderTitle, InputOnChangeData, OverlayDrawer, SearchBox, useRestoreFocusSource, useRestoreFocusTarget } from "@fluentui/react-components"
import { Dismiss24Regular } from "@fluentui/react-icons";
import { IConsumptionsFilters } from "../../../../../models/Filters/ConsumptionsFilters";
import ProtocolPatientSelectorComponent from "../../../../../commons/component/Inputs/ProtocolPatientSelector/ProtocolPatientSelector.Component";
import { ProtocolPatient } from "../../../../../models/Entities/Protocols/ProtocolPatient";
import { ContractConcept } from "../../../../../models/Entities/Contracts/ContractConcept";
import { ContractStage } from "../../../../../models/Entities/Contracts/ContractStage";
import { IConsumptionStatusProps } from "../../../../../commons/component/Inputs/ProtocolConsumptionStatusSelector/ProtocolConsumptionStatusSelector.Functions";
import { Practitioner } from "../../../../../models/Entities/Practitioners/Practitioner";
import ContractConceptSelectorComponent from "../../../../../commons/component/Inputs/ContractConceptSelector/ContractConceptSelector.Component";
import { CurrencySelectorComponent } from "../../../../../commons/component/Inputs/CurrencySelector/CurrencySelectorComponent";
import ContractStagesSelectorComponent from "../../../../../commons/component/Inputs/ContractStagesSelector/ContractStages.Selector.Component";
import PractitionerSelectorComponent from "../../../../../commons/component/Inputs/PractitionerSelector/PractitionerSelectorComponent";
import ProtocolConsumptionStatusSelectorComponent from "../../../../../commons/component/Inputs/ProtocolConsumptionStatusSelector/ProtocolConsumptionStatusSelector.Component";
import DateRangeSelectorComponent from "../../../../../commons/component/Inputs/DateRangeSelector/DateRangeSelector.Component";
import SettlementSelectorComponent from "../../../../../commons/component/Inputs/SettlementSelector/SettlementSelectorComponent";
import { Settlement } from "../../../../../models/Entities/Settlements/Settlement";


type IProps = {
    ProtocolId: number,
    ContractId: number,
    Filters: IConsumptionsFilters,
    isOpen: boolean,
    onClose: () => void,
    onFilterChange: (filters: IConsumptionsFilters) => void
}

const ConsumptionFilterPanel = (props: IProps) => {

    const [selectedPatients, setSelectedPatients] = useState<ProtocolPatient[]>(props.Filters.SelectedProtocolPatients);
    const [selectedContractConcepts, setSelectedContractConcepts] = useState<ContractConcept[]>(props.Filters.SelectedContractConcepts);
    const [selectedCurrency, setSelectedCurrency] = useState<string>(props.Filters.SelectedCurrencys);
    const [selectedContractStages, setSelectedContractStages] = useState<ContractStage[]>(props.Filters.SelectedContractStages);
    const [selectedPractitioners, setSelectedPractitioners] = useState<Practitioner[]>(props.Filters.SelectedPractitioners);
    const [selectedStatus, setSelectedStatus] = useState<IConsumptionStatusProps[]>(props.Filters.SelectedStatus);
    const [selectedSettlements, setSelectedSettlements] = useState<Settlement[]>(props.Filters.SelectedSettlements ?? []);
    const [filterText, setFilterText] = useState<string>();
    const [dateFrom, setDateFrom] = useState<Date | undefined>();
    const [dateTo, setDateTo] = useState<Date | undefined>();

    useEffect(() => {
        setSelectedPatients(props.Filters.SelectedProtocolPatients);
        setSelectedContractConcepts(props.Filters.SelectedContractConcepts);
        setSelectedCurrency(props.Filters.SelectedCurrencys);
        setSelectedContractStages(props.Filters.SelectedContractStages);
        setSelectedPractitioners(props.Filters.SelectedPractitioners);
        setSelectedStatus(props.Filters.SelectedStatus);
        setSelectedSettlements(props.Filters.SelectedSettlements ?? []);
        setFilterText(props.Filters.FilterText);
        setDateFrom(props.Filters.SelectedDateRange[0]);
        setDateTo(props.Filters.SelectedDateRange[1]);
    },[
        props.Filters.SelectedProtocolPatients,
        props.Filters.SelectedContractConcepts,
        props.Filters.SelectedCurrencys,
        props.Filters.SelectedContractStages,
        props.Filters.SelectedPractitioners,
        props.Filters.SelectedStatus,
        props.Filters.SelectedSettlements,
        props.Filters.FilterText,
        props.Filters.SelectedDateRange
    ]);

    const handleClosePanel = () => {

         const CurrentFilter: IConsumptionsFilters = {
             SelectedConsumptions: [],
             SelectedProtocolPatients: selectedPatients,
             SelectedContractConcepts: selectedContractConcepts,
             SelectedCurrencys: selectedCurrency,
             SelectedContractStages: selectedContractStages,
             SelectedPractitioners: selectedPractitioners,
             SelectedStatus: selectedStatus,
             SelectedSettlements: selectedSettlements,
             FilterText: filterText,
             SelectedProtocols: [],
             SelectedDateRange: [dateFrom, dateTo],
             showGroupedByVisit: props.Filters.showGroupedByVisit,
             GroupId: undefined,
         }

        props.onFilterChange(CurrentFilter);

        props.onClose();
    }

    return (
        <OverlayDrawer
            //{...restoreFocusSourceAttributes}
            open={props.isOpen}
            position="end"
            onOpenChange={handleClosePanel}
        >
            <DrawerHeader>
                <DrawerHeaderTitle
                    action={
                        <Button
                            appearance="subtle"
                            aria-label="Close"
                            icon={<Dismiss24Regular />}
                            onClick={handleClosePanel}
                        />
                    }
                >
                    Filtros
                </DrawerHeaderTitle>
            </DrawerHeader>

            <DrawerBody>
                <>
                    <SearchBox style={{ width: '100%' }} value={filterText} onChange={(ev: any, data: InputOnChangeData) => setFilterText(data.value)} />
                    <div>
                        <div>
                            <ProtocolPatientSelectorComponent
                                ProtocolId={props.ProtocolId}
                                onSelectedProtocolPatient={(patients: ProtocolPatient[]) => { patients ? setSelectedPatients(patients) : setSelectedPatients([]) }}
                                ProtocolPatientsSelectedNumber={selectedPatients?.map((pat: ProtocolPatient) => { return pat.numberInProtocol })}
                                MultiselectEnable={true}
                            />
                        </div>
                        <div>
                            <ContractConceptSelectorComponent
                                ContractId={props.ContractId}
                                referralDate={undefined}
                                onSelectedContractConcept={(contractConcepts: ContractConcept[]) => setSelectedContractConcepts(contractConcepts)}
                                ContractConceptsSelected={selectedContractConcepts?.map((contractConcept: ContractConcept) => contractConcept.id)}
                                MultiselectEnable={true}
                            />
                        </div>
                        <div>
                            <CurrencySelectorComponent
                                errorMessage={undefined}
                                defaultSelected={selectedCurrency}
                                label={'Seleccione una moneda'}
                                onCurrencyChange={(currency: string) => currency ? setSelectedCurrency(currency) : setSelectedCurrency('')}
                                disabled={false}
                                isRequired={false}
                            />
                        </div>
                        <div>
                            <ContractStagesSelectorComponent
                                ContractId={props.ContractId}
                                onSelectedContractStage={
                                    (stages: ContractStage[]) => {
                                        stages !== undefined || stages?.[0] !== undefined ? setSelectedContractStages(stages) : setSelectedContractStages([])
                                    }
                                }
                                ContractStagesSelected={selectedContractStages?.map((contractStage: ContractStage) => contractStage.id)}
                                MultiselectEnable={true} />
                        </div>
                        <div>
                            <PractitionerSelectorComponent
                                onChangeSelection={(practitioners: Practitioner[] | undefined) => { practitioners !== undefined || practitioners?.[0] !== undefined ? setSelectedPractitioners(practitioners) : setSelectedPractitioners([]) }}
                                MultiselectEnable={true}
                                SelectedPractitioners={selectedPractitioners?.map((practitioner: Practitioner) => practitioner.userId) || []}
                            />
                        </div>
                        <div>
                            <ProtocolConsumptionStatusSelectorComponent
                                ContractId={0}
                                onSelectedStatus={
                                    (status: IConsumptionStatusProps[]) => {
                                        status !== undefined || status?.[0] !== undefined ? setSelectedStatus(status) : setSelectedStatus([])
                                    }
                                }
                                statusSelected={
                                    selectedStatus?.map((status: IConsumptionStatusProps) => status.id)
                                }
                                MultiselectEnable={true}
                            />
                        </div>
                        <div>
                            <SettlementSelectorComponent
                                protocolId={props.ProtocolId}
                                selectedSettlements={selectedSettlements}
                                onChangeSelection={(settlements: Settlement[] | undefined) =>
                                    setSelectedSettlements(settlements ?? [])
                                }
                            />
                        </div>
                        <div>
                            <DateRangeSelectorComponent
                                startDateLabel="Desde"
                                endDateLabel="Hasta"
                                onDateChange={(dateFrom: Date | undefined, dateTo: Date | undefined) => {
                                    setDateFrom(dateFrom);
                                    setDateTo(dateTo);
                                } }
                                startDate={dateFrom}
                                endDate={dateTo} 
                                className={""}                            
                            />
                        </div>
                    </div>
                    {/* <Separator />
                    <div className='ConsumptionMarks'>
                        <Checkbox
                            checked={showConsumptionWithAmountInZero}
                            onChange={(ev, data) => data.checked ? setShowConsumptionWithAmountInZero(true) : setShowConsumptionWithAmountInZero(false)}
                            label="Mostrar consumos con monto en cero"
                        />
                        <Checkbox
                            checked={showConsumptionIgnored}
                            onChange={(ev, data) => data.checked ? setShowConsumptionIgnored(true) : setShowConsumptionIgnored(false)}
                            label="Mostrar consumos ignorados"
                        />
                    </div> */}
                </>
            </DrawerBody>
            <DrawerFooter>
                {/* <Button appearance="secondary" onClick={() => props.onClose()}>Cancelar</Button> */}
                <Button appearance="primary" onClick={handleClosePanel}>Aplicar</Button>
            </DrawerFooter>
        </OverlayDrawer>
    )

}

export default ConsumptionFilterPanel;	